module.exports = __webpack_public_path__ + "img/f1ed7b589ca0aac5559ba52338bf716d.svg";